import { HttpClient } from '../HttpClient';
/**
 * * Get Pendo Data
 */

export const GetPendoData = async () => {
  try {
    const { data } = await HttpClient.get(`api/Pendo/HRParameters`);
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
